module.exports = {"title":"Propaganda","subtitle":"Você deseja adicionar outra VeloeTag em sua conta? Clique em adicionar e veja que rápido de fazer.","button":"Link"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/advertise/data.json
// module id = 2230
// module chunks = 0